import React from 'react';
import styles from './style.module.css';
import { BackPage, Forms, OrderBar } from 'components';
import { useHistory } from 'react-router-dom';
import useQuery from 'hooks/useQuery';

const AddNewAddressByPostcode = () => {
  const query = useQuery();
  const history = useHistory();
  const accountView = query.get('view') === 'account';

  return (
    <>
      {!accountView && <OrderBar currentProgress={0} />}
      <BackPage onBackClick={() => history.goBack()}>
        <h1 className={styles.header}>Add a new address</h1>
        <p className={styles.subheader}>When your order is approved, we can send to any UK address.</p>
        <Forms.AddNewAddressByPostcodeForm />
      </BackPage>
    </>
  );
};

export default AddNewAddressByPostcode;
